import env from '@beam-australia/react-env';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import useTheme from '@mui/styles/useTheme';
import PropTypes from 'prop-types';
import { InstilLogo } from '@/assets/images';
import OrgName from '@/components/common/OrgName';
import PublicRoutes from '@/constants/routing/PublicRoutes';
import translate from '@/lib/intl/translate';

function AuthContainer({ size, navLinkText, navLinkRoute, orgName, children }) {
  const helpLinkAddress = env('HELP_LINK_ADDRESS');
  const privacyLink = env('PRIVACY_LINK');
  const theme = useTheme();

  return (
    <Container className="mt-0 px-6 py-3 md:mt-14" maxWidth={size}>
      <Box
        sx={{
          marginBottom: 1,
          borderRadius: 1,
          borderColor: theme.palette.grey[600],
          borderWidth: '1px',
          padding: {
            xs: 3,
            sm: 7,
          },
        }}
      >
        <Box
          alignItems="center"
          display="flex"
          sx={{ marginBottom: { xs: 4, sm: 6 } }}
        >
          <Box
            display="flex"
            alignItems={{ xs: 'left', sm: 'center' }}
            flexDirection={{ xs: 'column', sm: 'row' }}
          >
            <RouterLink to={PublicRoutes.LANDING}>
              <InstilLogo alt={translate('INSTIL_LOGO_ALT')} className="w-28" />
            </RouterLink>
            <OrgName orgName={orgName} />
          </Box>
          {navLinkText && navLinkRoute && (
            <div className="ml-auto">
              <Link
                component={RouterLink}
                data-testid="auth-container-nav-link"
                to={{ pathname: navLinkRoute }}
              >
                {navLinkText}
              </Link>
            </div>
          )}
        </Box>
        <div className="mt=6">{children}</div>
      </Box>
      <div className="flex w-full justify-center child:mx-6 sm:justify-end">
        <Link href={`mailto:${helpLinkAddress}`}>{translate('HELP_LINK')}</Link>
        <Link href={privacyLink} rel="noopener noreferrer" target="_blank">
          {translate('PRIVACY_LINK')}
        </Link>
      </div>
    </Container>
  );
}

AuthContainer.propTypes = {
  children: PropTypes.node.isRequired,
  navLinkRoute: PropTypes.string,
  navLinkText: PropTypes.string,
  orgName: PropTypes.string,
  size: PropTypes.string.isRequired,
};

AuthContainer.defaultProps = {
  navLinkText: '',
  navLinkRoute: '',
  orgName: null,
};

export default AuthContainer;
